module.exports = __webpack_public_path__ + "img/Hut.22cd20f4.svg";